import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/site/Nav";
import Leadership from "@/components/site/Leadership";
import TrustedBy from "@/components/site/TrustedBy";
import Impact from "@/components/site/Impact";
import Awards from "@/components/site/Awards";
import FounderNote from "@/components/site/FounderNote";
import Footer from "@/components/site/Footer";
import BookConsultationDialog from "@/components/site/BookConsultationDialog";
import JoinUsDialog from "@/components/site/JoinUsDialog";
import FloatingActions from "@/components/site/FloatingActions";
import { track } from "@/lib/analytics";
import { usePageMeta } from "@/lib/usePageMeta";
import { AWARDS } from "@/data/content";

export default function LeadershipPage() {
  const [bookOpen, setBookOpen] = useState(false);
  const [joinOpen, setJoinOpen] = useState(false);
  const { hash } = useLocation();

  usePageMeta({
    title: "Leadership — BLEZZINGS",
    description:
      "Meet Khalid Kamal Rumi, Founder & CEO of BLEZZINGS — 16+ years across marketing, strategy and P&L leadership, and the philosophy behind the firm.",
    canonical: "https://blezzings.co/leadership",
    breadcrumbs: [
      { name: "Home", url: "https://blezzings.co/" },
      { name: "Leadership", url: "https://blezzings.co/leadership" },
    ],
    person: {
      name: "Khalid Kamal Rumi",
      jobTitle: "Founder & CEO",
      alumniOf: "Indian Institute of Management Indore",
      sameAs: "https://www.linkedin.com/in/khalidkamalrumi/",
      awards: AWARDS.map((a) => `${a.title} — ${a.body}, ${a.year}`),
    },
  });

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace(/^#/, "");
    const target = document.getElementById(id);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
    }
  }, [hash]);

  const openBook = (source = "unknown") => {
    track("book_consultation_open", { source });
    setBookOpen(true);
  };

  return (
    <div data-testid="leadership-page" className="relative">
      <Nav onBook={() => openBook("nav")} />
      <div className="pt-20 md:pt-24" aria-hidden />
      <Leadership onBook={() => openBook("leadership")} />
      <TrustedBy />
      <Impact />
      <Awards />
      <FounderNote onBook={() => openBook("founder-note")} />
      <Footer onJoin={() => setJoinOpen(true)} />
      <FloatingActions onBook={() => openBook("floating")} />
      <BookConsultationDialog open={bookOpen} onOpenChange={setBookOpen} />
      <JoinUsDialog open={joinOpen} onOpenChange={setJoinOpen} />
    </div>
  );
}
